import React, {ReactNode} from "react";
import {CustomFlowbiteTheme, Flowbite} from "flowbite-react";

export const appTheme: CustomFlowbiteTheme = {
  button: {
    color: {
      blue: "font-normal border border-transparent rounded-full bg-bc-blue text-white focus:ring-4 focus:ring-bc-blue enabled:hover:bg-bc-blue dark:bg-bc-blue dark:hover:bg-bc-blue dark:focus:ring-bc-blue",
      gray: "font-normal bg-neutral-100 border rounded-full border-neutral-100 text-neutral-400 focus:text-neutral-400 focus:ring-4 enabled:hover:bg-neutral-100 enabled:hover:text-neutral-400 dark:border-neutral-400 dark:text-neutral-400 dark:enabled:hover:bg-neutral-400 dark:enabled:hover:text-neutral-100",
    },
  },
};


type AppContainerProps = {
  children: ReactNode
}

export default function AppContainer({children}: AppContainerProps) {
  return (
      <Flowbite theme={{theme: appTheme}}>
        <div className="w-screen container">
        <div className="md:mt-4 mt-2 md:mx-4 mx-1 mb-8 md:mb-32">
          {children}
        </div>
        </div>
      </Flowbite>
  );
}
